import { render, staticRenderFns } from "./ProxerSettings.vue?vue&type=template&id=6798da89&scoped=true&"
import script from "./ProxerSettings.vue?vue&type=script&lang=js&"
export * from "./ProxerSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProxerSettings.vue?vue&type=style&index=0&id=6798da89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6798da89",
  null
  
)

export default component.exports